









































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { TextMSGDTO } from '@/interfaces/DialogNewRolUsuario.interface'
import { HTTP } from '@/plugins/axios'
import { BoletoDTO } from '@/interfaces/Boleto.interface'
import { BoletoDescuentoDTO } from '@/interfaces/DialogNewDescuentoBoleto.interface'

@Component
export default class DialogNewBoleto extends Vue {
  @Prop({ type: Object })
  private info!: BoletoDTO
  @Prop({ type: String })
  private action!: string
  @Prop({ type: Boolean })
  private update!: boolean
  @Prop({ type: Array })
  private descuentos!: BoletoDescuentoDTO[]
  private money: any = {
    decimal: '.',
    thousands: '',
    prefix: '',
    suffix: '',
    precision: 2,
    masked: false
  }
  private name: string = 'DialogNewBoleto'
  private mModel: BoletoDTO = {
    cost: 0.00,
    folioBeg: 0,
    folioEnd: 0,
    name: '',
    img: '',
    comment: '',
    status: false
  }
  private bModel: BoletoDTO = {
    cost: 0.00,
    folioBeg: 0,
    folioEnd: 0,
    name: '',
    img: '',
    comment: '',
    status: false
  }
  private mainHost: string = process.env.VUE_APP_AXIOS_BASE_URL
  private uploadIMG: any = {}
  private dialog: boolean = false
  private cost: number = 0
  private mAction: string = 'new'
  private titleNew: string = 'Agregar Boleto'
  private titleMod: string = 'Modificar Boleto'
  private textMSG: TextMSGDTO = {
    success: {
      text: 'Nuevo Boleto:',
      color: 'success'
    },
    update: {
      text: 'Modificado Boleto:',
      color: 'info'
    },
    fail: {
      text: 'Error al guardar:',
      color: 'error'
    },
  }

  private get DescuentosValidos (): BoletoDescuentoDTO[] {
    let res: BoletoDescuentoDTO[] = []
    if (this.descuentos.length > 0) {
      res = this.descuentos.map((d) => {
        if (!d.status) {
          return d
        }
      })
    }
    return res
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    // if (typeof this.info === 'object') this.mModel = Object.assign({}, this.info)
    if (typeof this.action === 'object') this.mAction = this.action
  }

  @Watch('info')
  private watchInfo (v: BoletoDTO) {
    if (typeof v === 'object') {
      this.mModel = Object.assign({}, v)
      this.mAction = 'edit'
      this.dialog = true
    }
  }

  @Watch('dialog')
  private watchDialog (v: boolean) {
    if (!v) {
      this.mModel = Object.assign({}, this.bModel)
      this.mAction = 'new'
      this.$emit('update:action', this.mAction)
    }
  }

  @Emit('update')
  private emitUpdate (v: boolean) {
    console.log('emitUpdate :: ', v)
    this.$emit('update:update', v)
  }

  private onFileSelected (item: any) {
      console.log('onFileSelected', item)
      const image = item.target.files[0]

      this.uploadIMG = item.target.files[0]

      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = (e: any) => {
        console.log('e :: ', e)
        this.mModel.img = e.target.result
      }
    }

  private CreateBoleto (item: BoletoDTO) {
    console.log('CreateBoleto :: ', item)
    HTTP.post('boleto/', item)
      .then((response: any) => {
        console.log('CreateBoleto :: response :: ', response.data)
        this.emitUpdate(response.data.success)

        if (this.uploadIMG !== null) {
          this.uploadIMG.id = response.data.info.id

          let data = new FormData()
          data.append('img', this.uploadIMG)

          HTTP.post('boleto/' + response.data.info.id + '/image', data, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then((respons: any) => {
              console.log('response', respons.data)
            })
            .catch((error: any) => {
              console.log(error)
              alert(error)
          })
        }

        this.dialog = false
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.success.text + ' ' + item.name,
          color: this.textMSG.success.color,
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('CreateBoleto :: catch :: ', e.response.data)
        this.dialog = false
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.fail.text + ' ' + item.name,
          color: this.textMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }

  private UpdateBoleto (item: BoletoDTO) {
    console.log('UpdateBoleto :: ', item)
    HTTP.put('boleto/' + item.id, item)
      .then((response: any) => {
        console.log('UpdateBoleto :: response :: ', response.data)

        if (this.uploadIMG !== null) {
          this.uploadIMG.id = response.data.info.id

          let data = new FormData()
          data.append('img', this.uploadIMG)

          HTTP.post('boleto/' + response.data.info.id + '/image', data, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then((respons: any) => {
              console.log('response', respons.data)
            })
            .catch((error: any) => {
              console.log(error)
              alert(error)
          })
        }

        this.emitUpdate(response.data.success)
        this.dialog = false
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.update.text + ' ' + item.name,
          color: this.textMSG.update.color,
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('UpdateBoleto :: catch :: ', e.response.data)
        this.dialog = false
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.fail.text + ' ' + item.name,
          color: this.textMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }
}
